<template>
	<div>
		<el-card class="box-card">
			<h3 style="text-align: left;">合作意向管理</h3>
			<el-form :inline="true" :model="form" size="mini" class="demo-form-inline" style="text-align: left;">
				<el-form-item label="合作客户" style="margin-left:8px;">
					<el-input v-model="form.customer_name" placeholder="客户名称"></el-input>
				</el-form-item>
				<el-form-item label="意向内容">
					<el-input v-model="form.hzyx" placeholder="意向内容"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="searchHZYX">查询</el-button>
					<el-button type="primary" icon="el-icon-refresh" @click="getHzyx">全部</el-button>
				</el-form-item>
			</el-form>
			<el-table stripe :header-cell-style="{'text-align':'center'}" :data="tableData" size="mini" border
				style="width: 100%">
				<el-table-column prop="CUSTOMER_NAME" label="客户名称" width="240">
				</el-table-column>
				<el-table-column prop="SZDQ" label="所在地区" width="100">
				</el-table-column>
				<el-table-column prop="HZFS" label="合作方式" width="100">
				</el-table-column>
				<el-table-column prop="HZYX" label="合作意向">
					<div slot-scope="scope">
						<div :type="scope.row.HZYX">
							<span v-if="scope.row.HZYX.length<20">
								{{scope.row.HZYX}}
							</span>
							<div v-else>
								<el-popover placement="top-start" width="300" trigger="hover" style=""
									:content="scope.row.HZYX">
									<span slot="reference" class="mypop">
										{{
											scope.row.HZYX.substring(0,20)+"..."
										}}
									</span>
								</el-popover>
							</div>
						</div>
					</div>
				</el-table-column>
				<el-table-column prop="OPRTTIME" label="提交日期" width="140" align="center">
					<template slot-scope="scope">
						{{ scope.row.OPRTTIME | formatter('yyyy-MM-dd hh:mm:ss') }}
					</template>
				</el-table-column>
				<el-table-column prop="DFNR" label="答复内容">
					<div slot-scope="scope">
						<div :type="scope.row.DFNR">
							<span v-if="scope.row.DFNR.length<20">
								{{scope.row.DFNR}}
							</span>
							<div v-else>
								<el-popover placement="top-start" width="300" trigger="hover" style=""
									:content="scope.row.DFNR">
									<span slot="reference" class="mypop">
										{{
											scope.row.DFNR.substring(0,20)+"..."
										}}
									</span>
								</el-popover>
							</div>
						</div>
					</div>
				</el-table-column>
				<el-table-column prop="DFTIME" label="答复日期" width="140" align="center">
					<template slot-scope="scope">
						{{ scope.row.DFTIME | formatter('yyyy-MM-dd hh:mm:ss') }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" fixed="right" width="80">
					<template slot-scope="scope">
						<el-link icon="el-icon-edit" :underline="false" @click="reply(scope.row)">答复</el-link>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin-top:20px;text-align: left;" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes"
				:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</el-card>
		<el-dialog title="答复合作意向" class="my-cust-class" :visible.sync="dialogVisible" :close-on-click-modal="false"
			style="text-align: left;line-height:30px;" width="40%">
			<div>客户名称：{{dfShowInfo.CUSTOMER_NAME}}</div>
			<div>合作方式：{{dfShowInfo.HZFS}}</div>
			<div>合作意向：{{dfShowInfo.HZYX}}</div>
			<el-input type="textarea" v-model="dfnr" style="margin-top:10px;" :rows="4" placeholder="答复内容"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">取 消</el-button>
				<el-button type="primary" :disabled="dfnr.length<1" @click="doreply">答 复</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					customer_name: '',
					hzyx: ''
				},
				tableData: [],
				currentPage: 1,
				pageSizes: [20, 40, 60, 80, 100],
				pageSize: 20,
				total: 1,
				dialogVisible: false,
				mid: '', //	当前答复意向的ID
				dfnr: '',
				dfShowInfo: {
					CUSTOMER_NAME: '',
					HZFS: '',
					HZYX: ''
				},
				queryInfo: {
					page: '',
					rows: '',
					para: {}
				}
				
			}
		},
		created() {
			this.getHzyx()
		},
		methods: {
			getHzyx() {
				let self = this
				self.form={
					customer_name: '',
					hzyx: ''
				}
				let url = 'http://www.liligc.com/NWCenter/dlCustTest'
				self.axios.get(url, {
					params: {
						action: 'GetHZYX',
						page: self.currentPage,
						rows: self.pageSize
					}
				}).then(function(res) {
					if (res.data.rows) {
						self.tableData = res.data.rows
						self.total = res.data.total
					} else {
						this.$message.error('服务不可用');
					}
				}).catch(function(err) {
					this.$message.error(err);
				});
			},
			reply(row) {
				let self = this
				self.dialogVisible = true
				self.mid = row.HZYXID
				self.dfShowInfo = {
					CUSTOMER_NAME: row.CUSTOMER_NAME,
					HZFS: row.HZFS,
					HZYX: row.HZYX
				}
			},
			doreply() {
				let self = this
				if (self.dfnr == '') {
					this.$message.error('答复内容不能为空');
					return;
				}
				var para = {
					"hzyxid": self.mid,
					"dfnr": self.dfnr,
				}
				let url = 'http://www.liligc.com/NWCenter/dlCustTest?action=SaveHZYXDF'
				self.axios.get(url, {
					params: {
						'para': JSON.stringify(para)
					}
				}).then(function(res) {
					if (res.data.result) {
						self.getHzyx()
					} else {
						this.$message.error('服务不可用');
					}
				}).catch(function(err) {
					this.$message.error(err);
				}).finally(() => {
					self.closeDialog()
				});
			},
			closeDialog() {
				let self = this
				self.dfnr = ''
				self.dfShowInfo = {}
				self.mid = ''
				self.dialogVisible = false
			},
			searchHZYX() {
				let self = this
				var para = self.form
				let url = 'http://www.liligc.com/NWCenter/dlCustTest'
				self.axios.get(url, {
					params: {
						action: 'GetHZYX',
						page: 1,
						rows: self.pageSize,
						para: JSON.stringify(para)
					}
				}).then(function(res) {
					if (res.data.rows) {
						self.tableData = res.data.rows
						self.total = res.data.total
					} else {
						this.$message.error('服务不可用');
					}
				}).catch(function(err) {
					this.$message.error(err);
				});
			},
			handleSizeChange(val) {
				let self = this
				self.pageSize = val
				self.getHzyx()
			},
			handleCurrentChange(val) {
				let self = this
				self.currentPage = val
				self.getHzyx()
			}
		},
		mounted() {

		}
	}
</script>

<style lang="less" scoped>
	.box-card {
		margin: 10px;
	}

	.mypop {
		text-decoration: underline;
		color: #6495ED;
		text-underline-offset: 0.3em;
		cursor: pointer;
	}

	.my-cust-class {
		::v-deep {
			.el-dialog__body {
				padding: 0 10px 10px 10px;
			}
		}
	}
</style>
